import React from 'react';

const SkeletonLoader = ({ variant = 'card', count = 1, className = '' }) => {
  const renderSkeleton = () => {
    switch (variant) {
      case 'card':
        return (
          <div className={`bg-white/80 backdrop-blur-sm rounded-2xl p-4 md:p-6 shadow-elevation-2 border border-fintech-blue-100 animate-pulse ${className}`}>
            <div className="flex items-start justify-between mb-4">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-gray-200 to-gray-300" />
              <div className="w-16 h-6 rounded-lg bg-gradient-to-r from-gray-200 to-gray-300" />
            </div>
            <div className="space-y-3">
              <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/3 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
              <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-2/3 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
              <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/2 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
            </div>
          </div>
        );
      
      case 'table-row':
        return (
          <div className={`bg-card rounded-xl p-3 md:p-4 border border-border animate-pulse ${className}`}>
            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-gray-200 to-gray-300 flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-3/4 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
                <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/2 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
              </div>
              <div className="w-20 h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
            </div>
          </div>
        );
      
      case 'chart':
        return (
          <div className={`bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2 animate-pulse ${className}`}>
            <div className="space-y-4">
              <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/3 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
              <div className="h-64 bg-gradient-to-br from-gray-100 via-gray-200 to-gray-100 rounded-xl flex items-end justify-around p-4 gap-2">
                {[...Array(7)]?.map((_, i) => (
                  <div
                    key={i}
                    className="bg-gradient-to-t from-gray-300 to-gray-200 rounded-t w-full animate-pulse"
                    style={{ height: `${Math.random() * 60 + 40}%`, animationDelay: `${i * 0.1}s` }}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      
      case 'text':
        return (
          <div className={`space-y-2 ${className}`}>
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-full animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-5/6 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-4/6 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <>
      {[...Array(count)]?.map((_, index) => (
        <div key={index}>
          {renderSkeleton()}
        </div>
      ))}
    </>
  );
};

export default SkeletonLoader;